import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
    selector: 'location-change-dialog',
    templateUrl: './location-change-dialog.component.html',
    styleUrls: ['./location-change-dialog.component.scss'],
})
export class LocationChangeDialogComponent {
    constructor(@Inject(MAT_DIALOG_DATA) public data: any) {}
}
